import * as typesImp from './shared/types/types';
import * as authorizerImp from './shared/authentication/Authorizer';
import * as sigv4authorizerimp from './shared/authentication/Sigv4Authorizer';
import * as ApikeyManagerImp from './apikey-manager/ApikeyManager';
import * as ATRApikeyManagerImp from './apikey-manager/ATRApikeyManager';
import * as DataConverterManagerImp from './data-converter-manager/DataConverterManager';
import * as ATRDataConverterManagerImp from './data-converter-manager/ATRDataConverterManager';
import * as DeviceProfileManagerImp from './device-profile-manager/DeviceProfileManager';
import * as ATRDeviceProfileManagerImp from './device-profile-manager/ATRDeviceProfileManager';
import * as DeviceManagerImp from './device-manager/DeviceManager';
import * as ATRDeviceManagerImp from './device-manager/ATRDeviceManager';
export var shared;
(function (shared) {
    let types;
    (function (types) {
        types.DeviceConnectivity = typesImp.DeviceConnectivity;
        types.deserializeDeviceConnectivity = typesImp.deserializeDeviceConnectivity;
    })(types = shared.types || (shared.types = {}));
    let auth;
    (function (auth) {
        let models;
        (function (models) {
            models.Credentials = authorizerImp.Credentials;
        })(models = auth.models || (auth.models = {}));
        let sigv4;
        (function (sigv4) {
            sigv4.SigV4Authorizer = sigv4authorizerimp.SigV4Authorizer;
            sigv4.SigV4Crendentials = sigv4authorizerimp.SigV4Crendentials;
            sigv4.SigV4RequestDescriptor = sigv4authorizerimp.SigV4RequestDescriptor;
        })(sigv4 = auth.sigv4 || (auth.sigv4 = {}));
    })(auth = shared.auth || (shared.auth = {}));
})(shared || (shared = {}));
export var apikey;
(function (apikey) {
    let models;
    (function (models) {
        models.NewApikey = ApikeyManagerImp.NewApikey;
        models.ApikeyPatch = ApikeyManagerImp.ApikeyPatch;
        models.Apikey = ApikeyManagerImp.Apikey;
    })(models = apikey.models || (apikey.models = {}));
    let assettracking;
    (function (assettracking) {
        assettracking.ATRApikeyManager = ATRApikeyManagerImp.ATRApikeyManager;
    })(assettracking = apikey.assettracking || (apikey.assettracking = {}));
})(apikey || (apikey = {}));
export var device;
(function (device) {
    let models;
    (function (models) {
        models.NewDeviceModel = DeviceManagerImp.NewDevice;
        models.AdditionalParams = DeviceManagerImp.AdditionalParams;
        models.DevicePatch = DeviceManagerImp.DevicePatch;
        models.Device = DeviceManagerImp.Device;
    })(models = device.models || (device.models = {}));
    let assettracking;
    (function (assettracking) {
        assettracking.ATRDeviceManager = ATRDeviceManagerImp.ATRDeviceManager;
        assettracking.ATRNewDevice = ATRDeviceManagerImp.ATRNewDevice;
        assettracking.LoRaTTNAdditionalParams = ATRDeviceManagerImp.LoRaTTNAdditionalParams;
        assettracking.PolarisAdditionalParams = ATRDeviceManagerImp.PolarisAdditionalParams;
        assettracking.ATRDevicePatch = ATRDeviceManagerImp.ATRDevicePatch;
        assettracking.ATRDevice = ATRDeviceManagerImp.ATRDevice;
    })(assettracking = device.assettracking || (device.assettracking = {}));
})(device || (device = {}));
export var deviceprofile;
(function (deviceprofile) {
    let models;
    (function (models) {
        models.DeviceProfile = DeviceProfileManagerImp.DeviceProfile;
        models.NewDeviceProfile = DeviceProfileManagerImp.NewDeviceProfile;
    })(models = deviceprofile.models || (deviceprofile.models = {}));
    let assettracking;
    (function (assettracking) {
        assettracking.ATRDeviceProfileManager = ATRDeviceProfileManagerImp.ATRDeviceProfileManager;
        assettracking.ATRNewDeviceProfileSigfox = ATRDeviceProfileManagerImp.ATRNewDeviceProfileSigfox;
        assettracking.ATRNewDeviceProfileLorattn = ATRDeviceProfileManagerImp.ATRNewDeviceProfileLorattn;
        assettracking.ATRNewDeviceProfileLoraloriot = ATRDeviceProfileManagerImp.ATRNewDeviceProfileLoraloriot;
        assettracking.ATRNewDeviceProfileLoramachineq = ATRDeviceProfileManagerImp.ATRNewDeviceProfileLoramachineq;
        assettracking.ATRNewDeviceProfileLoraactility = ATRDeviceProfileManagerImp.ATRNewDeviceProfileLoraactility;
        assettracking.ATRLoraTTNProfileContext = ATRDeviceProfileManagerImp.ATRLoraTTNProfileContext;
        assettracking.ATRSigfoxProfileContext = ATRDeviceProfileManagerImp.ATRSigfoxProfileContext;
    })(assettracking = deviceprofile.assettracking || (deviceprofile.assettracking = {}));
})(deviceprofile || (deviceprofile = {}));
export var dataconverter;
(function (dataconverter) {
    let models;
    (function (models) {
        models.DataConverter = DataConverterManagerImp.DataConverter;
    })(models = dataconverter.models || (dataconverter.models = {}));
    let assettracking;
    (function (assettracking) {
        assettracking.ATRDataConverterManager = ATRDataConverterManagerImp.ATRDataConverterManager;
        assettracking.ATRDataConverter = ATRDataConverterManagerImp.ATRDataConverter;
    })(assettracking = dataconverter.assettracking || (dataconverter.assettracking = {}));
})(dataconverter || (dataconverter = {}));
//# sourceMappingURL=export.js.map